import {AuthenticationService} from './authentication.service';
import {Directive, Input, ElementRef, effect, inject} from '@angular/core';
import {UserService} from "../services/user.service";
import {Subscription} from 'rxjs';

@Directive({
    selector: '[require]',
    standalone: true
})
export class AuthorisationDirective {

  // require can be list of permissions - any 1 can be true
  @Input('require')
  public requirePermission?: string;

  private authService = inject(AuthenticationService);
  private userService = inject(UserService);
  private element = inject<ElementRef<HTMLElement>>(ElementRef);

  private setHidden(shouldHide: boolean): void {
    const hostStyle = this.element.nativeElement?.style;
    if (!hostStyle) {
      return;
    }

    hostStyle.display = shouldHide ? 'none' : '';
  }

  constructor() {
    effect((onCleanup) => {
      const authed = this.authService.isAuthenticated();
      const required = (this.requirePermission || '')
        .split(';')
        .map(permission => permission.trim())
        .filter(Boolean);

      if (!authed) {
        this.setHidden(required.length > 0);
        return;
      }

      const subscription: Subscription = this.userService.getUserPolicies().subscribe(permissions => {
        const shouldHide = required.length > 0 && !required.some(permission => permissions.includes(permission));
        this.setHidden(shouldHide);
      });

      onCleanup(() => subscription.unsubscribe());
    });
  }
}
